import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const PasswordEditIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.183 16.25H6.25c-.517 0-.975-.017-1.383-.075-2.192-.242-2.783-1.275-2.783-4.092V7.917c0-2.817.592-3.85 2.783-4.092.408-.058.867-.075 1.383-.075h2.883m3.384 0h1.233a9.96 9.96 0 0 1 1.383.075c2.192.242 2.783 1.275 2.783 4.092v4.167c0 2.817-.592 3.85-2.783 4.092-.408.058-.867.075-1.383.075h-1.233M12.5 1.666v16.667"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.245 10.001h.007m-3.34 0h.007"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  </SVGIcon>
);

export default PasswordEditIcon;
